<template>
  <v-data-table
    fixed-header
    :height="height"
    hide-default-footer
    disable-pagination
    disable-sort
    :headers="headers"
    :items="leads"
    :mobile-breakpoint="0"
    class="v-lead-list-component"
    v-on="$listeners"
  >

    <template v-for="(headerSlot, index) in headerSlots" v-slot:[headerSlot.slot]="{header}">
      <span :key="'sorticon' + index"
            class="sort-indicator-icon"
            v-if="typeof headerSlot.sortingIcon !== 'undefined'">
        <SortIndicationIcon :class="{rotate:headerSlot.sortingIcon === sorting.DSC}"/>
      </span>
      <span :key="'headertext' + index" :ref="'header' + header.value">
        {{ header.text }}
      </span>
    </template>

    <template v-slot:item="{item, headers, index}">
      <tr @click="() => {if(item.clickable){$emit('click:row', item)}}" :class="{clickable:item.clickable}">
        <td v-for="(header, colIndex) in headers" :key="'row' + index + 'col' + colIndex"
            :class="{'button-column': header.type === columnTypes.ACCEPT || header.type === columnTypes.DECLINE}">
          <div
            v-if="header.type === columnTypes.ACCEPT"
            class="accept-icon-wrapper"
            height="100%"
            width="100%"
            @click.stop="$emit('accept', item)">
            <AcceptIcon/>
          </div>

          <div
            v-if="header.type === columnTypes.DECLINE"
            class="decline-icon-wrapper"
            height="100%"
            width="100%"
            @click.stop="$emit('decline', item)">
            <DiscardIcon/>
          </div>

          <div v-if="header.type === columnTypes.TEXT" :style="{color:colors[header.value]}">
            {{item[header.value]}}
          </div>

          <div v-if="header.type === columnTypes.DATE" :style="{color:colors[header.value]}">
            {{dateToString(item[header.value])}}
          </div>
        </td>

      </tr>
    </template>

  </v-data-table>
</template>

<script>
import {computed, onMounted} from '@vue/composition-api'

import DiscardIcon from "@/components/icons/DiscardIcon";
import AcceptIcon from "@/components/icons/AcceptIcon";
import SortIndicationIcon from '../icons/SortIndicationIcon'

const sorting = {
  ASC: 0,
  DSC: 1
}

const columnTypes = {
  ACCEPT: 0,
  DECLINE: 1,
  TEXT: 2,
  DATE: 3
}

export default {
  name: "LeadListComponent",
  components: {
    SortIndicationIcon,
    AcceptIcon, DiscardIcon
  },
  props: {
    headers: Array,
    leads: Array,
    height: String
  },
  setup(props, context) {

    onMounted(() => {
      headerSlots.value.forEach((header) => {
        if (header.verticalSeparator) {
          context.refs['header' + header.value][0].parentElement.classList.add('vertical-separator')
        }
      })
    })

    function dateToString(date) {
      const formatter = new Intl.DateTimeFormat('de', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
      formatter.formatToParts(date);
      const fDate = (m_ca, m_it) => Object({...m_ca, [m_it.type]: m_it.value});
      const dateParts = formatter.formatToParts(date).reduce(fDate, {});
      return dateParts.day + '.' + dateParts.month + '.' + dateParts.year + ' ' + dateParts.hour + ':' + dateParts.minute;
    }

    const headerSlots = computed(() => props.headers.map(header => {
      return {...header, slot: 'header.' + header.value}
    }))
    const itemSlots = computed(() => props.headers.map(header => {
      return {...header, slot: 'item.' + header.value}
    }))

    const colors = computed(() => {
      let colors = {}
      props.headers.forEach(header => {
        if (header.color) colors[header.value] = header.color
      })
      return colors
    })

    return {dateToString, headerSlots, itemSlots, sorting, columnTypes, colors}
  },
  columnTypes,
  sorting
}
</script>

<style scoped lang="scss">
.v-lead-list-component {
  border-radius: 5px;
  overflow: hidden;

  .sort-indicator-icon .rotate {
    transform: rotate(180deg);
  }
}
</style>

<style lang="scss">
.v-lead-list-component {
  &.theme--light.v-data-table {

    // Table Header
    &.v-data-table--fixed-header thead {
      th {
        box-shadow: 10px 6px 10px rgba(0, 0, 0, .16);
        color: $primary;
        font-size: 18px;
        line-height: 22px;
        padding-top: 4px;
        height: 64px;

        .sort-indicator-icon {
          padding-right: 5px;
        }
      }
    }

    .vertical-separator::before {
      position: absolute;
      right: 0;
      content: '|';
      font-size: 18px;
      font-weight: 700;
    }

    .clickable {
      cursor: pointer;
    }

    // Body
    tbody {
      .button-column {
        width: 115px;
        padding: 0;
      }

      tr {
        // striped background
        &:nth-of-type(2n+1) {
          background-color: rgba(0, 0, 0, .05);
        }

        // Cell styling
        td {
          border-right: 1px solid rgba(#8EA2A8, .2);
          border-bottom: none !important;
          font-size: 16px;
          font-weight: 500;
          line-height: 21px;
          height: 64px;

          &:last-child {
            border-right: none;
          }

          .accept-icon-wrapper,
          .decline-icon-wrapper {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;

            &:hover {
              svg {
                .a, .b {
                  stroke: #73998E;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
